<!-- C3-6 / 04 §3.6: ngx-gauge -> vng-gauge (vng-gauge mirrors ngx-gauge's API 1:1:
     value/min/max/type/thick/size/foregroundColor keep the same names; the plain
     `label` input is superseded by projected content the same way ngx-gauge did).
     <ngx-gauge-append>/<ngx-gauge-label>/<ngx-gauge-prepend>/<ngx-gauge-value>
     wrapper *elements* become plain elements carrying the corresponding
     vngGaugeAppend/vngGaugeLabel/vngGaugePrepend/vngGaugeValue *attribute* (the
     append/prepend slots are plain <ng-content select="[attr]"> — no directive
     needed; label/value are backed by VngGaugeLabelDirective/VngGaugeValueDirective,
     both added to app.module.ts). The blank `<ngx-gauge-value> </ngx-gauge-value>`
     override becomes an empty `<span vngGaugeValue></span>` (documented "presence
     alone blanks the reading" behavior, COMPONENT-API.md). -->
<div class="margin-inset" style="display:flex; justify-content:space-between; gap:1em">
  <vng-gauge [foregroundColor]="flycut.foregroundColor" type="full" [thick]="flycut.thickness" [size]="flycut.size"
    [value]="isGrowth() ? 1 : flycut.value" [label]="flycut.name" [max]="flycut.designatedTotal">
    <strong vngGaugeAppend *ngIf="isGrowth() || flycut.designatedTotal == -1">&infin;</strong>
    <strong vngGaugeAppend *ngIf="!isGrowth() && flycut.designatedTotal != -1">{{
      flycut.designatedTotal
      }}</strong>
    <div vngGaugeLabel style="display:flex; justify-content:center; align-items:center; gap:.5em">
      <svg [vngTooltip]="
          isStarter()
            ? 'You can add a maximum of 300 FlyCuts. Upgrade to Growth plan to add an unlimited number of FlyCuts.'
            : isGrowth()
            ? 'You have an unlimited amount of FlyCuts.'
            : 'You can add a maximum of 20 FlyCuts. Upgrade to Starter or Growth Plan to add more.'
        " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
          style="fill: var(--vng-color-accent)" />
      </svg>
      <span>FlyCuts</span>
    </div>
    <strong vngGaugePrepend>{{ flycut.value }}&nbsp;/</strong>
    <span vngGaugeValue></span>
  </vng-gauge>

  <vng-gauge [foregroundColor]="flyplate.foregroundColor" type="full" [thick]="flyplate.thickness"
    [size]="flyplate.size" [value]="isGrowth() ? 1 : flyplate.value" [label]="flyplate.name"
    [max]="flyplate.designatedTotal">
    <strong vngGaugeAppend *ngIf="isGrowth() || flyplate.designatedTotal == -1">&infin;</strong>
    <strong vngGaugeAppend *ngIf="!isGrowth() && flyplate.designatedTotal != -1">{{
      flyplate.designatedTotal
      }}</strong>
    <div vngGaugeLabel style="display:flex; justify-content:center; align-items:center; gap:.5em">
      <svg [vngTooltip]="
          isStarter()
            ? 'You can add a maximum of 50 additional FlyPlates in addition to all general FlyPlates. Upgrade to Growth plan to add an unlimited of FlyPlates from our library.'
            : isGrowth()
            ? 'You have access to any and/or all of our FlyPlates across any category.'
            : 'You have access to all FlyPlates under the ‘General’ category. Upgrade to Starter or Growth to add FlyPlates from other categories.'
        " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
          style="fill: var(--vng-color-accent)" />
      </svg>
      <span>FlyPlates</span>
    </div>
    <strong vngGaugePrepend>{{ flyplate.value }}&nbsp;/</strong>
    <span vngGaugeValue></span>
  </vng-gauge>

  <vng-gauge [foregroundColor]="category.foregroundColor" type="full" [thick]="category.thickness"
    [size]="category.size" [value]="isGrowth() ? 1 : category.value" [label]="category.name"
    [max]="category.designatedTotal">
    <strong vngGaugeAppend *ngIf="isGrowth()">&infin;</strong>
    <strong vngGaugeAppend *ngIf="!isGrowth()">{{ category.designatedTotal }}</strong>
    <div vngGaugeLabel style="display:flex; justify-content:center; align-items:center; gap:.5em">
      <svg [vngTooltip]="
          isStarter()
            ? 'You can create a maximum of 14 Categories. Upgrade to Growth Plan to add more.'
            : isGrowth()
            ? 'You have an unlimited amount of Categories.'
            : 'You can create a maximum of 7 Categories. Upgrade to Starter or Growth Plan to add more.'
        " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
          style="fill: var(--vng-color-accent)" />
      </svg>
      <span>Categories</span>
    </div>
    <strong vngGaugePrepend>{{ category.value }}&nbsp;/</strong>
    <span vngGaugeValue></span>
  </vng-gauge>

  <vng-gauge [foregroundColor]="subcategory.foregroundColor" type="full"
    [thick]="subcategory.thickness" [size]="subcategory.size" [value]="isGrowth() ? 1 : subcategory.value"
    [label]="subcategory.name" [max]="subcategory.designatedTotal">
    <strong vngGaugeAppend *ngIf="isGrowth()">&infin;</strong>
    <strong vngGaugeAppend *ngIf="!isGrowth()">{{ subcategory.designatedTotal }}</strong>
    <strong vngGaugePrepend>{{ subcategory.value }}&nbsp;/</strong>
    <div vngGaugeLabel style="display:flex; justify-content:center; align-items:center; gap:.5em">
      <svg [vngTooltip]="
          isStarter()
            ? 'You can create a maximum of 28 Subcategories. Upgrade to Growth Plan to add more.'
            : isGrowth()
            ? 'You have an unlimited amount of SubCategories.'
            : 'You can create a maximum of 14 Subcategories. Upgrade to Starter or Growth Plan to add more.'
        " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
          style="fill: var(--vng-color-accent)" />
      </svg>
      <span>Subcategories</span>
    </div>
    <span vngGaugeValue></span>
  </vng-gauge>
</div>

<div style="display:flex; flex-direction:column; justify-content:space-evenly; align-items:center; gap:.5em">
  <div class="usage-info-card" style="display:flex; justify-content:flex-start; align-items:center; gap:.5em">
    <svg [vngTooltip]="
        isGrowth()
          ? 'You have an unlimited amount of Characters per FlyMSG.'
          : isStarter()
          ? 'Your current plan allows you to add up to 25,000 characters. Upgrade to Growth to have access to an UNLIMITED amount of characters per FlyMSG. '
          : 'Your current plan allows you to add up to 2,500 characters per FlyMSG. Upgrade to have access to a higher amount of characters.'
      " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
        style="fill: var(--vng-color-accent)" />
    </svg>
    <span class="text-title"> Characters:</span>
    <span class="text-info">{{ isGrowth() || characters == -1 ? "Unlimited" : characters }} per
      FlyMSG</span>
  </div>
  <div class="usage-info-card" style="display:flex; justify-content:flex-start; align-items:center; gap:.5em">
    <svg [vngTooltip]="
        isStarter()
          ? 'Your current plan allows you to have access to spell checks for one selected language. Upgrade to Growth to spell check for all languages.'
          : isGrowth()
          ? 'Your current plan allows you to have access to spell checks for all languages.'
          : 'Your current plan allows you to have access to spell checks for English only. Upgrade to have access to other languages.'
      " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
        style="fill: var(--vng-color-accent)" />
    </svg>
    <span class="text-title"> Spell Check:</span>
    <span class="text-info">{{
      isGrowth()
      ? "All Languages"
      : isStarter()
      ? "1 Selected Language"
      : "English ONLY"
      }}</span>
  </div>
  <div class="usage-info-card" style="display:flex; justify-content:flex-start; align-items:center; gap:.5em">
    <svg [vngTooltip]="
        !isFreemium()
          ? 'Your current plan allows text styling for all fonts and all sizes.'
          : 'Your current plan allows you to have text styling to 12 point Arial font. Upgrade to have access to all text styling.'
      " vngTooltipPosition="bottom" width="12" height="12" viewBox="0 0 12 12" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM6 3C6.41421 3 6.75 3.33579 6.75 3.75V3.7575C6.75 4.17171 6.41421 4.5075 6 4.5075C5.58579 4.5075 5.25 4.17171 5.25 3.7575V3.75C5.25 3.33579 5.58579 3 6 3ZM6.75 5.6325C6.75 5.21828 6.41421 4.8825 6 4.8825C5.58579 4.8825 5.25 5.21828 5.25 5.6325V8.2575C5.25 8.67171 5.58579 9.0075 6 9.0075C6.41421 9.0075 6.75 8.67171 6.75 8.2575V5.6325Z"
        style="fill: var(--vng-color-accent)" />
    </svg>
    <span class="text-title"> Text Styling:</span>
    <span class="text-info">{{
      isFreemium() ? "12pt Arial font" : "All fonts in all sizes"
      }}</span>
  </div>
</div>
